/**
 * 企业端 — 运输单管理（列表 + 状态筛选）
 */
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchOrders } from '@/api/transit';
import { Empty, Loading, PageHeader, OrderStatusTag } from '@/components/common';
import type { TransitOrder } from '@/types';
import { fmtTime, quarantineStatusText } from '@/utils/format';

const statusFilter = [
  { label: '全部', value: '' },
  { label: '待装车', value: 0 },
  { label: '运输中', value: 1 },
  { label: '已到达', value: 2 },
  { label: '已签收', value: 3 },
  { label: '已完成', value: 4 },
  { label: '已取消', value: 5 },
];

export default function EntOrders() {
  const [orders, setOrders] = useState<TransitOrder[]>([]);
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState<number | ''>('');

  useEffect(() => {
    setLoading(true);
    fetchOrders(status === '' ? {} : { status }).then((d) => {
      setOrders(d.list);
      setLoading(false);
    });
  }, [status]);

  if (loading) return <Loading />;

  return (
    <div>
      <PageHeader
        title="运输单管理"
        sub="创建运输单并驱动状态机：待装车 → 运输中 → 已到达 → 已签收"
        extra={
          <Link className="btn btn-primary" to="/enterprise/orders/new">
            ＋ 新建运输单
          </Link>
        }
      />
      <div className="card">
        <div className="row" style={{ marginBottom: 14 }}>
          {statusFilter.map((f) => (
            <button
              key={String(f.value)}
              className={`btn btn-sm ${status === f.value ? 'btn-primary' : 'btn-ghost'}`}
              onClick={() => setStatus(f.value as number | '')}
            >
              {f.label}
            </button>
          ))}
        </div>
        {orders.length === 0 ? (
          <Empty text="暂无运输单" />
        ) : (
          <table className="table">
            <thead>
              <tr>
                <th>运输单号</th>
                <th>来源</th>
                <th>路线</th>
                <th>牛只</th>
                <th>状态</th>
                <th>检疫</th>
                <th>创建时间</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              {orders.map((o) => (
                <tr key={o.id}>
                  <td style={{ fontFamily: 'monospace', fontSize: 12 }}>{o.transit_no}</td>
                  <td>
                    {o.source_order_no ? (
                      <a
                        href={`https://trade.yunniuji.com/orders/${o.order_id}`}
                        target="_blank"
                        rel="noreferrer"
                        style={{ fontSize: 12 }}
                        title="跳转交易平台查看订单"
                      >
                        交易订单 {o.source_order_no} ↗
                      </a>
                    ) : (
                      <span style={{ fontSize: 12, color: 'var(--color-ink-muted)' }}>—</span>
                    )}
                  </td>
                  <td>
                    {o.origin_city} → {o.destination_city}
                  </td>
                  <td>{o.cattle_count} 头</td>
                  <td>
                    <OrderStatusTag status={o.status} />
                  </td>
                  <td>{quarantineStatusText(o.quarantine_status)}</td>
                  <td style={{ fontSize: 12, color: 'var(--color-ink-secondary)' }}>{fmtTime(o.created_at)}</td>
                  <td>
                    <Link className="btn btn-sm btn-ghost" to={`/enterprise/orders/${o.id}`}>
                      管理
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
